import { render, staticRenderFns } from "./AdditionalRealProperty.vue?vue&type=template&id=05a987fa"
import script from "./AdditionalRealProperty.vue?vue&type=script&lang=js"
export * from "./AdditionalRealProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports